import { toast } from 'react-toastify';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
//초기화를 위해사용
import { PURGE } from 'redux-persist';
// utils
import * as dto from 'src/utils/dto';
import { decodeToken } from 'src/utils/jwt';
import {
  cleanObject,
  headers,
  jsonHeader,
  saltmineJsonHeader,
  saltmineJwtHeaders,
  saltmineSMSHeader,
  urls
} from '../../libs/reqConf';
import { errorHandle, isMobile } from '../../utils/function';
import { getCloseLoading, getLoading } from './loading';
import { getOpen, setError } from './modal';

// ----------------------------------------------------------------------

const initialState = {
  isLogin: false,
  error: false,
  verifyNumber: '',
  veryifId: '',
  isVerify: '',
  myProfile: {},
  phoneNumber: '',
  agreement: {},
  user: {},
  registerData: {
    name: '',
    nickname: '',
    phoneNumber: '',
    isPhoneVerified: false,
    identifier: '',
    password: '',
    birthDate: '',
    passwordConfirm: '',
    agreeTermsOfService: false,
    agreePrivacyPolicy: false,
    agreeThirdPartyInformationSharing: false,
    verify: false,
    agreeMarketing: false
  }
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.dto;
    },
    userReset(state) {
      // immer를 사용하여 직접 상태를 수정
      Object.assign(state, initialState);
    },

    // 로그인 성공
    getLoginSuccess(state, action) {
      state.isLogin = true;
      state.user = action.dto;
    },

    getRegisterAgree(state, action) {
      const newAgreeState = action.dto;

      state.registerData = {
        ...state.registerData,
        ...newAgreeState
      };
    },

    getProfileSuccess(state, action) {
      state.myProfile = action.dto;
    },

    getAgreementSuccess(state, action) {
      state.agreement = action.dto;
    },

    getVerifyNumberSuccess(state, action) {
      state.verifyNumber = action.dto.token;
      state.veryifId = action.dto._id;
      state.phoneNumber = action.dto.phoneNumber;
    },

    getVerifyCheckSuccess(state, action) {
      if (action.dto === 'success') {
        state.isVerify = true;
      } else {
        state.isVerify = false;
      }
    },

    // 로그인 성공
    getProfileUpdateSuccess(state, action) {
      state.user = action.dto;
    },

    // 로그아웃 성공
    getLogoutSuccess(state) {
      state.isLogin = false;
      state.user = {};
    },

    // 프로필 수정
    changeMyProfile(state, action) {
      state.myProfile = { ...state.myProfile, ...action.dto };
    },

    // 모바일 연동
    changeMobileInfo(state, action) {
      const { user, accessToken } = action.dto;
      state.isLogin = true;
      state.user = user;
      window.localStorage.setItem('accessToken', accessToken);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  onToggleFollow,
  getLogoutSuccess,
  userReset,
  changeMyProfile,
  getRegisterAgree,
  getVerifyCheckSuccess,
  changeMobileInfo
} = slice.actions;

// ----------------------------------------------------------------------
//회원가입

export function getEnroll(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/account/create`;
      const body = dto.createEnroll(params);
      const config = { headers: saltmineJsonHeader() };
      const response = await axios.post(url, body, config);

      if (response?.data?.status === Number(200)) {
        return (window.location.href = '/register-done');
      }
    } catch (error) {
      console.log('error', error);
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
// 계정 찾기

export function getCheckId(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/account/check-conflict`;
      const body = dto.checkId(params);
      const config = { headers: saltmineJsonHeader() };
      const response = await axios.post(url, body, config);

      return response.data.data;
    } catch (error) {
      console.log('error', error);
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
// 프로필 조회
export function getProfile() {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}/profile`;
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);

      dispatch(slice.actions.getProfileSuccess(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
//동의항목 조회
export function getAgreement() {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}/setting/agreement`;
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);

      dispatch(slice.actions.getAgreementSuccess(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
//동의항목 수정
export function patchAgreement(params) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}/setting/agreement`;
      const body = params;
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.patch(url, params, config);

      // dispatch(slice.actions.getAgreementSuccess(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
//로그인
export function getLogin(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/account/login`;
      const body = dto.postLogin(params);
      const config = { headers: saltmineJsonHeader() };
      const response = await axios.post(url, body, config);

      const accessToken = response.data.data.accessToken;
      window.localStorage.setItem('accessToken', accessToken);
      dispatch(slice.actions.getLoginSuccess());
      dispatch(getProfile());
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
//로그아웃
export function getLogout() {
  return async (dispatch) => {
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.auth}/logout`;
      const body = {};
      const config = { headers: saltmineJwtHeaders(accessToken) };
      await axios.post(url, body, config);

      // 모바일 버전 싱크 맞추기 위해 일정시간 텀을 둠
      isMobile && window.ReactNativeWebView?.postMessage('logout');
      setTimeout(
        () => {
          dispatch(slice.actions.getLogoutSuccess());
          window.localStorage.clear();
        },
        isMobile ? 500 : 0
      );
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
//토큰 재발행
export function getRefreshToken() {
  return async (dispatch) => {
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.user}/settings/token/refresh`;
      const body = { test: 'test' };
      const config = { headers: headers(accessToken) };
      const response = await axios.post(url, body, config);

      window.localStorage.setItem('accessToken', response.data.data.accessToken);
      accessToken = response?.data?.data?.accessToken;
      return accessToken;
    } catch (error) {
      console.log('error', error.response);
      dispatch(setError(errorHandle(error)));
    }
  };
}
// ----------------------------------------------------------------------
// 프로필 수정
export function updateProfile(data) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}/profile-text`;
      const body = dto.updateProfile(data);
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.patch(url, body, config);

      if (response.data.message === 'success') {
        dispatch(slice.actions.getProfileSuccess(response.data.data));
        dispatch(getVerifyCheckSuccess(false));
        toast.success('수정이 되었습니다.');
        return response.data.message;
      }
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
//비밀번호 변경
export function updatePassword(params) {
  return async (dispatch) => {
    try {
      let accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}/password`;
      const body = cleanObject(params);
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.patch(url, body, config);
      if (response.data.message === 'success') {
        toast.success('비밀번호가 변경되었습니다.');
        return response.data.message;
      }
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
//비밀번호 재설정
export function resetPassword(params) {
  return async (dispatch) => {
    try {
      // const accessToken = await checkTokenAndRefresh(dispatch);
      const url = `${urls.auth}/password-reset`;
      const body = cleanObject(params);
      const smsVerifyToken = window.localStorage.getItem('smsVerifyToken');
      const config = { headers: saltmineSMSHeader(smsVerifyToken) };
      const response = await axios.patch(url, body, config);

      if (response.data.message === 'success') {
        toast.success('비밀번호가 재설정되었습니다.');
        return response.data.message;
      }
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}
// ----------------------------------------------------------------------
// sms 문자인증 요청
export function smsVerifyRequest(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/sms-verify-request`;
      const body = dto.postSmsVerify(params);

      const config = { headers: saltmineJsonHeader() };
      const response = await axios.post(url, body, config);
      window.localStorage.setItem('smsVerifyToken', response.data.data.token);

      return response.data;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}
// ----------------------------------------------------------------------
//계정 찾기 인증번호 재발송
export function resendVerification(params) {
  return async (dispatch) => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');

      const url = `${urls.user}/public/verification/resend`;
      const body = cleanObject(params);
      const config = { headers: headers(accessToken) };
      const response = await axios.post(url, body, config);
      dispatch(slice.actions.getVerifyNumberSuccess(response.data.data));
    } catch (error) {
      console.log('error', error?.response);

      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
// 아이디 찾기
export function findId() {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/account-find`;
      const smsVerifyToken = window.localStorage.getItem('smsVerifyToken');
      const config = { headers: saltmineSMSHeader(smsVerifyToken) };
      const response = await axios.post(url, {}, config);

      return response.data.data;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
//인증 번호 검증
export function smsVerify(params) {
  return async (dispatch) => {
    try {
      const url = `${urls.auth}/sms-verify`;
      const body = { code: String(params?.inputVerifyNumber) };
      const smsVerifyToken = window.localStorage.getItem('smsVerifyToken');
      const config = { headers: saltmineSMSHeader(smsVerifyToken) };
      const response = await axios.post(url, body, config);

      dispatch(slice.actions.getVerifyCheckSuccess(response.data?.message));
      if (response.data?.message === 'success') {
        if (params.findType === 'id') {
          const res = await dispatch(findId());

          dispatch(getOpen(`아이디:${res.identifier}`));
        }
        return { success: true, status: response.data.status };
      }
    } catch (error) {
      console.log('error', error?.response);

      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------
// 카카오 인증 URL 획득
export function getKakaoURL(type) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const url = `${urls.user}/public/auth/kakao/url?type=${type}`;
      const response = await axios.get(url);

      if (response?.data?.data?.url) {
        return (window.location.href = response?.data?.data?.url);
      }
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}
// ----------------------------------------------------------------------
// 카카오 로그인 & 회원가입 시도
export function postKakaoAuth(params) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const url = `${urls.user}/public/auth/kakao`;
      const body = params;
      const config = { headers: jsonHeader() };
      const response = await axios.post(url, body, config);
      const accessToken = response.data.data.accessToken;
      const decoded = decodeToken(accessToken);
      window.localStorage.setItem('accessToken', accessToken);
      dispatch(slice.actions.getLoginSuccess(decoded.agentID));
      dispatch(getProfile());
    } catch (error) {
      console.log('error: ', error);
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}
// ---------------------------------------------------------------------
// 서비스 탈퇴
export function deleteUser() {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const url = `${urls.account}`;
      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.delete(url, config);
      dispatch(getLogoutSuccess());
      return response.data.status;
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ---------------------------------------------------------------------
// 알람조회
